import { Box } from "@mui/material"

export default function EmptyDrawing(props: {
  infoMsg: string
  canvasW: number
  canvasH: number
}) {
  return (
    <Box
      width={props.canvasW}
      height={props.canvasH}
      style={{
        border: "1px solid #dfe0f2",
        borderRadius: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#3e3259",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          border: "3px solid #3e3259",
          borderRadius: "9999px",
          marginBottom: "20px",
          padding: "5px",
          height: "20px",
          width: "20px",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          fontSize: 24,
          fontWeight: "bold",
        }}
      >
        i
      </Box>
      <Box>{props.infoMsg}</Box>
    </Box>
  )
}
